import React, { FC } from 'react';
import { Maybe } from 't2-graphql-types';
import LinkButton from '../LinkButton/LinkButton';
import { getTerritoryChooseRolePageUrl } from '../../services/pagesUrl/getTerritoryChooseRolePageUrl';

type TJoinTerritoryButtonProps = {
  territorySlug?: Maybe<string>;
  onClick: () => void;
};

export const JoinTerritoryLinkButton: FC<TJoinTerritoryButtonProps> = ({ territorySlug, onClick }) => (
  <LinkButton
    href={territorySlug ? getTerritoryChooseRolePageUrl(territorySlug) : ''}
    variant="primary"
    disabled
    className="min-h-6 !px-5 md:!px-10 !font-normal whitespace-nowrap !w-full !py-[10px] justify-center rounded-[8px] !text-sm"
    onClick={onClick}
  >
    New Members Closed
  </LinkButton>
);
